import React from "react";
import {makeStyles} from "@material-ui/core/styles";
import ChatBubbleOutlineRoundedIcon from "@material-ui/icons/ChatBubbleOutlineRounded";

const useStyles = makeStyles(() => ({
    root: {
      width: "100%",
      minHeight: "calc(100vh - 52px)",
      background: "linear-gradient(135deg, #f7f9fa 0%, #edf3f6 100%)",
      display: "flex",
      justifyContent: "center",
      alignItems: "flex-start",
      padding: "55px 24px 24px",
      boxSizing: "border-box",
    },

    topbar: {
        height: 52,
        minHeight: 52,
        backgroundColor: "#236681",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 18,
        fontWeight: 600,
        boxShadow: "0 2px 5px rgba(0, 0, 0, 0.18)",
    },

    content: {
        flex: 1,
        display: "flex",
        justifyContent: "center", // centraliza horizontalmente
        alignItems: "flex-start", // posiciona na parte superior
        padding: "55px 24px 24px",
    },

    card: {
        width: "100%",
        maxWidth: 340,
        padding: "36px 28px",
        backgroundColor: "#fff",
        borderRadius: 14,
        boxShadow: "0 10px 35px rgba(35, 102, 129, 0.14)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },

    iconContainer: {
        position: "relative",
        width: 76,
        height: 76,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: 22,
    },

    iconCircle: {
        width: 62,
        height: 62,
        borderRadius: "50%",
        color: "#fff",
        background: "linear-gradient(135deg, #0782ad, #236681)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 7px 18px rgba(35, 102, 129, 0.28)",
        animation: "$pulse 1.8s ease-in-out infinite",
    },

    icon: {
        fontSize: 31,
    },

    title: {
        color: "#236681",
        fontSize: 20,
        fontWeight: 600,
        margin: 0,
    },

    description: {
        color: "#6f7f87",
        fontSize: 14,
        margin: "8px 0 22px",
        textAlign: "center",
    },

    dots: {
        display: "flex",
        gap: 7,
    },

    dot: {
        width: 8,
        height: 8,
        borderRadius: "50%",
        backgroundColor: "#0782ad",
        animation: "$bounce 1.2s ease-in-out infinite",

        "&:nth-child(2)": {
            animationDelay: "0.15s",
        },

        "&:nth-child(3)": {
            animationDelay: "0.3s",
        },
    },

    "@keyframes pulse": {
        "0%, 100%": {
            transform: "scale(1)",
        },
        "50%": {
            transform: "scale(1.06)",
        },
    },

    "@keyframes bounce": {
        "0%, 60%, 100%": {
            transform: "translateY(0)",
            opacity: 0.45,
        },
        "30%": {
            transform: "translateY(-6px)",
            opacity: 1,
        },
    },

    "@media (prefers-reduced-motion: reduce)": {
        iconCircle: {
            animation: "none",
        },
        dot: {
            animation: "none",
        },
    },
}));

const LoadingPage = () => {
  const classes = useStyles();

  return (
    <main className={classes.root}>
      <div className={classes.card}>
        <div className={classes.iconContainer}>
          <div className={classes.iconCircle}>
            <ChatBubbleOutlineRoundedIcon className={classes.icon} />
          </div>
        </div>

        <h1 className={classes.title}>Carregando</h1>

        <p className={classes.description}>
          Preparando seu ambiente de atendimento...
        </p>

        <div className={classes.dots} aria-label="Carregando">
          <span className={classes.dot} />
          <span className={classes.dot} />
          <span className={classes.dot} />
        </div>
      </div>
    </main>
  );
};

export default LoadingPage;